import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function MyCKEditor({
    data, 
    onChange, 
    disabled
}:
{
    data: any, 
    onChange?: Function, 
    disabled: boolean
}){
    class MyUploadAdapter {
        loader: any
        constructor(props: any){
            this.loader = props;
        }
        upload(){
            return new Promise((resolve) => {
                this._initListeners(resolve);
            })
        }
        _initListeners(resolve: any){
            resolve({
                default: this.loader._reader._data
            });
        }
    }
    const myCustomUploadAdapterPlugin = (editor: any) => {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader: any) => {
            return new MyUploadAdapter(loader);
        }
    }

    return (
        <CKEditor
            editor = {ClassicEditor} 
            onReady = {(editor: any) => {
                if(editor && disabled){
                    editor.sourceElement.nextElementSibling.children[1].style.display = "none";
                    editor.sourceElement.nextElementSibling.children[2].children[0].style.border = "none";
                }
                myCustomUploadAdapterPlugin(editor);
            }}
            disabled = {disabled}
            config = {{
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "|",
                    "indent",
                    "outdent",
                    "|",
                    "imageUpload",
                    "blockQuote",
                    "insertTable",
                    "mediaEmbed",
                    "undo", 
                    "redo",
                    "selectAll",
                ],
                // plugins: [
                //     "Essentials",
                //     "CKFinderUploadAdapter",
                //     "Autoformat",
                //     "Bold",
                //     "Italic",
                //     "BlockQuote",
                //     "CKFinder",
                //     "EasyImage",
                //     "Heading",
                //     "Image",
                //     "ImageCaption",
                //     "ImageStyle",
                //     "ImageToolbar",
                //     "ImageUpload",
                //     "Indent",
                //     "Link",
                //     "List",
                //     "MediaEmbed",
                //     "Paragraph",
                //     "PasteFromOffice",
                //     "Table",
                //     "TableToolbar",
                //     "TextTransformation"
                // ],
            }}
            data = {data}
            onChange = {(e: any, editor: any) => {
                if(typeof(onChange) === "function"){
                    onChange(e, editor);
                }
            }}
        />
    )
}